const ITEMS = [
  "Próxima apertura · enero",
  "Prerreserva sin compromiso",
  "Descuento en tu primer mes",
  "Prioridad para elegir tamaño",
  "Prerreserva abierta",
  "Calle Perú 2 · Guadalajara",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-brand-yellow text-brand-ink overflow-hidden py-3.5 border-y border-brand-ink/10 -rotate-[0.6deg] scale-[1.01]"
    >
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono text-sm font-bold tracking-[0.22em] uppercase whitespace-nowrap px-6 flex items-center gap-6"
              >
                {item}
                <span className="text-brand-ink/50">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
